const Forms =
    [
        {
            type: 'multipleSelect',
            options: 'CatCustomerName',
            label: 'company',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'CustomerName',
            id: 'CustomerName',
            id2: 'CustomerName',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        {
            type: 'multipleSelect',
            options: 'CatProduct',
            label: 'product',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'Product',
            id2: 'Product',
            id: 'Product',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        {
            type: 'Datetime',
            label: 'invoicing_date',
            name: 'InvoiceDate',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'InvoiceDate',
            id2: 'InvoiceDate',
            style : { fontSize : '11px',fontWeight:'bold'},
            value: "",
            format: "YYYY-MM-DD",
            values: []
        },
        {
            type: 'Datetime',
            label: 'due_date',
            name: 'DueDate',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'DueDate',
            id2: 'DueDate',
            style : { fontSize : '11px',fontWeight:'bold'},
            value: "",
            format: "YYYY-MM-DD",
            values: []
        },
        // {
        //     type: 'multipleSelect',
        //     options: 'CatType',
        //     label: 'Tipo',
        //     class: 'col-md-3 col-lg-3 col-sm-12',
        //     name: 'Type',
        //     id: 'Type',
        //     id2: 'Type',
        //     datatype: 'select',
        //     show: true,
        //     style: { fontSize: '11px', fontWeight: 'bold' },
        //     value: "",
        //     values: []
        // },
        {
            type: 'multipleSelect',
            options: 'CatStatus',
            label: 'status',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'Status',
            id2: 'Status',
            id: 'Status',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
    ]

export default Forms